import React, { useState, useEffect } from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import api from '../../../services/api';
import ProcurementSettingsComponent from './ProcurementSettings';
import SupplierApplications from './SupplierApplications';
import NewSupplierDetails from './NewSupplierDetails';
import SupplierGroups from './SupplierGroups';
import SupplierCompliance from './SupplierCompliance';

function Procurement() {
  return (
    <Routes>
      <Route path="/" element={<ProcurementIndex />} />
      <Route path="/rfq" element={<RFQManagement />} />
      <Route path="/suppliers" element={<SupplierManagement />} />
      <Route path="/supplier_applications" element={<SupplierApplications />} />
      <Route path="/new_supplier/:id" element={<NewSupplierDetails />} />
      <Route path="/compliance" element={<SupplierCompliance />} />
      <Route path="/settings" element={<ProcurementSettings />} />
      <Route path="/groups" element={<SupplierGroups />} />
      <Route path="*" element={<Navigate to="/dashboard/procurement" replace />} />
    </Routes>
  );
}

function ProcurementIndex() {
  return (
    <div>
      <div className="mb-6">
        <h1 className="text-2xl font-semibold text-gray-800">Procurement Management</h1>
      </div>
      
      <div className="bg-white rounded-lg shadow-md p-6">
        <p className="text-gray-600">Procurement dashboard will be implemented here.</p>
      </div>
    </div>
  );
}

function RFQManagement() {
  return (
    <div>
      <div className="mb-6">
        <h1 className="text-2xl font-semibold text-gray-800">RFQ Management</h1>
      </div>
      
      <div className="bg-white rounded-lg shadow-md p-6">
        <p className="text-gray-600">RFQ management will be implemented here.</p>
      </div>
    </div>
  );
}

function SupplierManagement() {
  return (
    <div>
      <div className="mb-6">
        <h1 className="text-2xl font-semibold text-gray-800">Supplier Management</h1>
      </div>
      
      <div className="bg-blue-50 border border-blue-200 rounded-lg p-6">
        <div className="flex items-center">
          <div className="flex-shrink-0">
            <svg className="h-5 w-5 text-blue-400" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
            </svg>
          </div>
          <div className="ml-3">
            <h3 className="text-sm font-medium text-blue-800">
              Supplier Management Moved
            </h3>
            <div className="mt-2 text-sm text-blue-700">
              <p>
                Supplier management has been moved to the Admin section for better organization. 
                You can now find suppliers under <strong>Admin → Suppliers</strong> in the sidebar menu.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

function ProcurementSettings() {
  return <ProcurementSettingsComponent />;
}

export default Procurement; 